import React from 'react';
import Login from './pages/Login/Login';
import Notas from './pages/Notas';
import { Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/notas" element={<Notas />} />
    </Routes>
  );
}

export default App;
